var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32481 18.7V4.03H8.13481C11.8248 4.03 14.8548 6.43 14.8548 11.41C14.8548 16.33 11.7948 18.7 8.10481 18.7H4.32481ZM8.2248 22C13.9848 22 18.6048 18.22 18.6048 11.41C18.6048 4.57 14.0448 0.729998 8.25481 0.729998H0.724805V22H8.2248Z",
    fill: "#8033cd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/D.a645d9c4.svg";
export { ForwardRef as ReactComponent };